import { useState, useEffect } from 'react';

export function useEditorDragDrop() {
  const [isDragging, setIsDragging] = useState(false);
  const [, setDragCounter] = useState(0);

  useEffect(() => {
    const handleDragEnter = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const hasFiles = e.dataTransfer?.types.includes('Files');
      if (!hasFiles) return;

      setDragCounter((prev) => {
        const newVal = prev + 1;
        if (newVal > 0) setIsDragging(true);
        return newVal;
      });
    };

    const handleDragLeave = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const hasFiles = e.dataTransfer?.types.includes('Files');
      if (!hasFiles) return;

      setDragCounter((prev) => {
        const newVal = prev - 1;
        if (newVal <= 0) {
          setIsDragging(false);
          return 0;
        }
        return newVal;
      });
    };

    const handleDrop = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();

      const hasFiles = e.dataTransfer?.types.includes('Files');
      if (!hasFiles) return;

      setIsDragging(false);
      setDragCounter(0);
    };

    const handleDragOver = (e: DragEvent) => {
      e.preventDefault();
      e.stopPropagation();
    };

    window.addEventListener('dragenter', handleDragEnter);
    window.addEventListener('dragleave', handleDragLeave);
    window.addEventListener('drop', handleDrop);
    window.addEventListener('dragend', handleDragLeave);
    window.addEventListener('dragover', handleDragOver);

    return () => {
      window.removeEventListener('dragenter', handleDragEnter);
      window.removeEventListener('dragleave', handleDragLeave);
      window.removeEventListener('drop', handleDrop);
      window.removeEventListener('dragend', handleDragLeave);
      window.removeEventListener('dragover', handleDragOver);
    };
  }, []);

  return { isDragging };
}
